<script setup lang="ts">
import { computed } from 'vue'
import VBadge from '@/modules/shared/components/VBadge.vue'
import { type Invoice } from '../types'

const props = defineProps<{
  status: Invoice['status']
}>()

const state = computed(() => {
  const s = props.status.split(' - ')[0] // this is to handle statuses like "Paid - #{self.payment_status}"
  switch (s) {
    case 'Deleted':
    case 'Past Due':
    case 'Invoice Canceled':
    case 'Declined':
    case 'Unpaid':
      return {
        color: 'V_UNPAID',
        label: props.status,
      }
    case 'Pending Settlement':
    case 'Paid':
    case 'Paid*':
      return {
        color: 'V_PAID',
        label: props.status,
      }
  }
})
</script>

<template>
  <VBadge v-if="status" :color="state.color" :dot="false" class="flex items-center gap-1">
    <span>{{ state.label }}</span>
  </VBadge>
</template>
